import { breakpoints, pxToRems, } from '@awaze/design-system.utils.react';
import styled from 'styled-components';
export const DepositIconStyled = styled.div `
  height: ${({ theme }) => pxToRems(theme.FontTextText200LineHeight)};
  margin-right: ${pxToRems(8)};
  display: flex;
  align-items: center;

  color: ${({ theme }) => theme.ColorStatusInfo50};

  svg {
    width: ${pxToRems(20)};
    height: ${pxToRems(20)};
  }
`;
export const DepositBannerStyled = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border-color: ${({ theme }) => theme.ColorStatusInfo500};
  background-color: ${({ theme }) => theme.ColorStatusInfo25};
  padding: ${pxToRems(8)} ${pxToRems(12)};
  border-radius: 4px;
  border-style: solid;
  border-width: 0px;
  color: ${({ theme }) => theme.ColorStatusInfo400};
`;
export const HighlightMessageStyled = styled.span `
  font-weight: ${({ theme }) => theme.FontTextText200BoldFontWeight};
  font-size: ${({ theme, fontSize }) => switchFontSize(theme, fontSize)};
`;
export const TermsMessageStyled = styled.span `
  display: block;
  font-weight: ${({ theme }) => theme.FontTextText100FontWeight};
  font-size: ${({ theme, fontSize }) => switchFontSize(theme, fontSize)};

  @media (min-width: ${breakpoints[0]}px) {
    display: inline;
  }
`;
export const StyledTextDiv = styled.div `
  ${({ theme, fontSize }) => fontSize === 100
    ? `line-height: ${pxToRems(theme.FontTextText100LineHeight)};`
    : ''}
`;
const switchFontSize = (theme, fontSize) => {
    switch (fontSize) {
        case 100:
            return pxToRems(theme.FontTextText100FontSize);
        case 200:
            return pxToRems(theme.FontTextText200FontSize);
    }
};
//# sourceMappingURL=deposit-banner.styles.js.map